export const setAuth = (token, user) => {
  localStorage.setItem('recupnet_token', token);
  localStorage.setItem('recupnet_user', JSON.stringify(user));
};

export const getAuth = () => {
  const token = localStorage.getItem('recupnet_token');
  const userStr = localStorage.getItem('recupnet_user');
  if (!token || !userStr) return null;
  try {
    return { token, user: JSON.parse(userStr) };
  } catch {
    return null;
  }
};

export const clearAuth = () => {
  localStorage.removeItem('recupnet_token');
  localStorage.removeItem('recupnet_user');
};

export const isAdmin = () => {
  const auth = getAuth();
  return auth?.user?.role === 'admin';
};

export const isClient = () => {
  const auth = getAuth();
  return auth?.user?.role === 'client';
};
